export const componentDefaults = {
  MuiButton: {
    defaultProps: {
      disableElevation: true,
    },
    styleOverrides: {
      root: {
        textTransform: "none",
      },
    },
  },
  MuiLink: {
    defaultProps: {
      underline: "hover",
    },
  },
};
